import { storeToRefs } from 'pinia';
import { useAsyncData } from 'nuxt/app';
import { useCareerStore } from '~~/common/stores/career';

// Binds the (email-domain dependent) career filters select-form to the render
// lifecycle: SSR-blocking, serialized into the payload, and refetched when the
// user identity changes via `watch: [careerFiltersKey]`.
export function useCareerFiltersSelectForm () {
  const careerStore = useCareerStore();
  const { careerFiltersKey } = storeToRefs(careerStore);

  return useAsyncData(
    careerFiltersKey.value,
    async () => careerStore.buildCareerFiltersSelectForm(await careerStore.fetchCareerAdvertisementFilters()),
    {
      watch: [careerFiltersKey],
      default: () => ({}),
    },
  );
}
